module.exports = __webpack_public_path__ + "assets/img/Logitech-PW-Australia-Landing-page.14ab560b.jpg";